import { createFileRoute } from "@tanstack/react-router";

import { HelpPage } from "@/components/marketing/help-page";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/(public)/help/")({
  head: () => pageHead("help"),
  component: HelpPage,
});
